import { createSelector } from '@ngrx/store';
import {
  impersonationSessionAdapter,
  impersonationSessionsFeature,
} from './impersonation-session.reducer';

export const {
  selectAdminImpersonationSessionsState,
  selectTotal: selectImpersonationSessionTotal,
  selectQuery: selectImpersonationSessionQuery,
  selectLoading: selectImpersonationSessionsLoading,
  selectRevokingId: selectImpersonationSessionRevokingId,
  selectError: selectImpersonationSessionsError,
} = impersonationSessionsFeature;

const entitySelectors = impersonationSessionAdapter.getSelectors(
  selectAdminImpersonationSessionsState,
);
export const selectAllImpersonationSessions = entitySelectors.selectAll;

export const selectImpersonationSessionPage = createSelector(
  selectImpersonationSessionQuery,
  (q) => q.page,
);
export const selectImpersonationSessionLimit = createSelector(
  selectImpersonationSessionQuery,
  (q) => q.limit,
);
